import React from 'react';
import { Link } from 'react-router-dom';
import { TbCheese, TbMeat } from "react-icons/tb";
import { GiTomato } from "react-icons/gi";
import { PiPlantBold } from "react-icons/pi";
import { LuCandy } from "react-icons/lu";

import './Combinacoes.scss'; // Importando o arquivo SCSS onde estão as classes CSS

function Combinacoes() {
  return (
    <div className="combinacoes-container">
      <div className='wrapper'>
        <div className='highlight'>
          + De 80 Combinações de sabores entre:
        </div>
        <div className='menuCategorias'>
          <Link to='cardapio' className="combinacoes-item">
            <div className="combinacoes-icon"><TbMeat /></div>
            <div className="combinacoes-text">Carnes</div>
          </Link>
          <Link to='cardapio' className="combinacoes-item">
            <div className="combinacoes-icon"><TbCheese /></div>
            <div className="combinacoes-text">Queijos</div>
          </Link>
          <Link to='cardapio' className="combinacoes-item">
            <div className="combinacoes-icon"><GiTomato /></div>
            <div className="combinacoes-text">Vegetais</div>
          </Link>
          <Link to='cardapio' className="combinacoes-item">
            <div className="combinacoes-icon"><PiPlantBold /></div>
            <div className="combinacoes-text">Vegans</div>
          </Link>
          <Link to='cardapio' className="combinacoes-item">
            <div className="combinacoes-icon"><LuCandy /></div>
            <div className="combinacoes-text">Doces</div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Combinacoes;
